import Image from "next/image";
import { useHeroStore } from "../../../stores/useHeroStore";
import TripAuditSection from "./TripAuditSection";

const HeroSection = () => {
  const clickCount = useHeroStore((state) => state.clickCount);
  const incrementClick = useHeroStore((state) => state.incrementClick);
  // Card data (unchanged)
  const cards = [
    {
      title: "Invoice Stamp Assessment",
      content: (
        <>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Driver Charge:</span> <br /> $ XXX.XX
          </div>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Damage Charge:</span> <br /> $ XXX.XX
          </div>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Excess Mileage Cost:</span> <br /> $
            XX.XX
          </div>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Total:</span> <br />{" "}
            <strong>$ XXX.XX</strong>
          </div>
        </>
      ),
    },
    {
      title: "Origin Stamp Assessment",
      content: (
        <>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Identity:</span> <br /> 2026 Range Rover
            Defender matched to <br />
            vehicle at origin
          </div>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Mileage:</span> <br /> Origin: 3,921 mi
          </div>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Vehicle Status:</span> <br />
            No new damage detected
          </div>
        </>
      ),
    },
    {
      title: "Impact Stamp Assessment",
      content: (
        <>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Identity:</span> <br /> 2026 Range Rover
            Defender matched to <br />
            vehicle at origin
          </div>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Mileage:</span> <br /> Origin: 3,921 mi
            → <br /> Return: 4,560 mi (639 driven mi)
          </div>
          <div className="rounded-[10px] border border-white/65 bg-[rgba(4,20,43,0.79)] px-4 py-1 text-[16px]">
            <span className="font-bold">Vehicle Status:</span> <br />
            Pre-existing damage remains; new minor <br /> dent (~2 in) detected
            on impact.
          </div>
        </>
      ),
    },
  ];

  const bgImages = [
    "/images/hero-front-car.svg",
    "/images/depurture_hero_bg.svg",
    "/images/hero-bg-image.svg",
    "/images/hero-front-car.svg",
  ];

  const iPhones = [
    "/images/iPhone_initial_2.svg",
    "/images/iPhone_departure.svg",
    "/images/iPhone_14_Pro.svg",
    "/images/iPhone_initial_2.svg",
  ];
  const currentCard = cards[clickCount % 3];
  const currentBgImage = bgImages[clickCount % bgImages.length];
  const currentIphone = iPhones[clickCount % iPhones.length];

  const handleStart = () => {
    document.getElementById("tripwise-section")?.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  const handlePhoneClick = () => {
    const nextCount = clickCount + 1;
    incrementClick(); // always advance

    // Scroll every time we land on the 4th state of a cycle (3, 7, 11…)
    if (nextCount % 4 === 3) {
      // small delay so the new background/phone image can start transitioning
      setTimeout(() => {
        handleStart();
      }, 300);
    }
  };

  return (
    <div
      key={clickCount}
      className=" bg-no-repeat h-full bg-cover bg-center  pt-10 relative animate-hero-bg transition-all duration-700"
      style={{ backgroundImage: `url('${currentBgImage}')` }}
    >
      <div className="max-w-360 mx-auto px-4 md:px-0 overflow-hidden ">
        {/* Title and input field*/}
        {/* Title and input field OR Assessment Card (mobile) */}
        <div className="max-w-228.25 mx-auto w-full md:mt-8 mt-2 space-y-2">
          {/* Desktop always shows title + input */}
          <div className="hidden md:block">
            <h2 className="text-center text-[28px] md:text-[32px] font-medium leading-tight md:leading-10">
              Eliminate vehicle condition disputes
            </h2>
            <h1 className="text-center text-[42px] md:text-[68px] font-extrabold leading-none capitalize">
              Stamp every handover
            </h1>
            <div className="mt-5">
              <TripAuditSection />
            </div>
          </div>

          {/* Mobile: show title + input only on first & last stage */}
          <div className="md:hidden">
            {clickCount === 0 || clickCount === 3 ? (
              <>
                <h2 className="text-center text-[28px] font-medium leading-tight">
                  Eliminate vehicle condition disputes
                </h2>
                <h1 className="text-center text-[42px] font-extrabold leading-none capitalize">
                  Stamp every handover
                </h1>
                <div className="mt-5">
                  <TripAuditSection />
                </div>
              </>
            ) : (
              /* Assessment card replaces title + input on mobile */
              <div className="w-full max-w-85 mx-auto animate-fade-in-top-left assessment-card-mobile">
                <div className="border border-white/65 bg-[rgba(4,20,43,0.85)] w-full rounded-[29.6px] p-5 overflow-auto backdrop-blur-sm">
                  <h3 className="text-center text-[24px] font-medium leading-tight bg-linear-to-r from-white to-white/20 bg-clip-text text-transparent mb-5">
                    {currentCard.title}
                  </h3>
                  <div className="space-y-4 text-sm text-white">
                    {currentCard.content}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* Main Content Area */}
        <div className="flex flex-col  md:flex-row items-center justify-center gap-10 md:gap-0  pb-12  assessment-card-mobile">
          {/* iPhone Mockup */}
          <div
            className="mx-auto md:absolute left-1/2 md:-translate-x-1/2 md:-bottom-16 mt-5 cursor-pointer "
            onClick={handlePhoneClick}
          >
            <div className="relative animate-phone animate-floating w-[100vw] mx-auto max-w-none md:w-auto md:max-w-none z-50 scale-110 md:scale-100 origin-center">
              <Image
                src={currentIphone}
                alt="phone image"
                width={650}
                height={531}
                priority
                className="transition-all duration-700 mx-auto -ml-2.5 md:ml-5.5 w-full h-auto"
              />
            </div>
          </div>

          {/* showing the assesment card on desktop */}
          {clickCount !== 0 && (
            <div
              key={clickCount}
              data-aos="zoom-in"
              className="absolute hidden md:block left-16 lg:left-20 bottom-8 animate-fade-in-top-left"
            >
              <div className="relative">
                <Image
                  src="/images/hero-shadow.svg"
                  alt="shadow"
                  width={700}
                  height={531}
                />

                {/* Dynamic Card */}
                <div
                  data-aos="zoom-in"
                  className="border h-100 w-115 absolute top-[2.1px] left-0 rounded-[29.6px] bg-[linear-gradient(180deg,rgba(37,99,234,0.79)_0%,rgba(0,31,99,0.80)_100%)] p-4 overflow-auto"
                >
                  <h3 className="text-center text-[32px] font-medium leading-10 bg-linear-to-r from-white to-white/20 bg-clip-text text-transparent mb-5">
                    {currentCard.title}
                  </h3>

                  <div className="space-y-4">{currentCard.content}</div>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
      {/* Decorative SVG */}
      <svg
        width="224"
        height="587"
        viewBox="0 0 224 587"
        fill="none"
        className="hidden lg:block absolute lg:right-[calc(12vw)] top-[12vh] pointer-events-none z-0"
      >
        <path
          d="M0 582.808L11.8994 586.407L9.06689 574.302L0 582.808ZM124.5 0.807617L123.789 1.61536C208.371 76.1537 235.926 206.253 214.131 325.043C192.337 443.834 121.282 550.877 9.16491 579.558L9.43174 580.601L9.69856 581.644C122.931 552.677 194.368 444.692 216.249 325.432C238.13 206.172 210.544 75.1985 125.212 -0.000124097L124.5 0.807617Z"
          fill="url(#paint0_linear_77_150)"
        />
        <defs>
          <linearGradient
            id="paint0_linear_77_150"
            x1="120.928"
            y1="0.807617"
            x2="120.928"
            y2="573.308"
            gradientUnits="userSpaceOnUse"
          >
            <stop stopColor="#0A7CFF" stopOpacity="0" />
            <stop offset="1" stopColor="#0A7CFF" />
          </linearGradient>
        </defs>
      </svg>
    </div>
  );
};

export default HeroSection;
